
const socketurl = "https://backend.biometricpro.app/";

// const url = "https://biometric-staging-backend.caprover-testing.mtechub.com/api/"
// const url='https://biometric-staging-backend.caprover-testing.mtechub.com/api/'
const url = "https://backend.biometricpro.app/api/"

// const  url ='http://192.168.18.107:4000/api/'
// const url ='https://biometric-staging-backend.caprover-testing.mtechub.com/api/'
// const url='https://backend.biometricpro.app/api/'

// const socketurl ='https://biometric-staging-backend.caprover-testing.mtechub.com/'

// const socketurl = "http://localhost:3050/";

// const url = "http://localhost:3050/api/"
export default url;
export { socketurl };

